import { XMarkIcon } from '@heroicons/react/16/solid';
import { Button, Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import AddWorkspaceUserForm from './AddWorkspaceUser.form.tsx';
import { useTeamContext } from '../../../Team.context.ts';

export default function AddTeamMemberModal() {
  const { t } = useTranslation('settings/team');
  const {
    addTeamMemberModalIsOpen,
    closeAddTeamMemberModal,
    addUserFormik,
  } = useTeamContext();


  // Reset form when modal closes
  useEffect(() => {
    if (!addTeamMemberModalIsOpen) {
      addUserFormik?.resetForm();
    }
  }, [addTeamMemberModalIsOpen, addUserFormik]);

  return (
    <Modal
      open={addTeamMemberModalIsOpen}
      className="TeamSection__Modal"
      responsive={true}
    >
      <Modal.Header className="TeamSection__Modal__Header">
        <h1>{t('page.form.label.modal-user-details.title')}</h1>
        <Button
          color="ghost"
          size="sm"
          shape="square"
          onClick={() => {
            // Goes through the flow's own close so the purchase intent rotates and
            // an abandoned disclosure is reported.
            closeAddTeamMemberModal();
            addUserFormik?.resetForm();
          }}
        >
          <XMarkIcon className="TeamSection__Modal__CloseIcon" />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <AddWorkspaceUserForm />
      </Modal.Body>
    </Modal>
  );
}
